import { AxiosResponse } from "axios";
import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import { ParameterFilterRequest } from "@/main/models/request/parameterFilterRequest";
import { ParameterTypesResponse } from "@/main/models/response/parameterTypesResponse";

export abstract class IParameterApi {
	abstract getDomain(request: ParameterFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;

	abstract getParametersByType(request: number): Promise<AxiosResponse<Result<KeyValue[]>>>;

	abstract getParameters(request: ParameterFilterRequest): Promise<AxiosResponse<Result<ParameterTypesResponse[]>>>;
}
